import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Colors from '../../shared/colors';
import ptLogoColor from '../../images/header/pt_logo_color.svg';
import enLogoColor from '../../images/header/en_logo_color.svg';

class NotFound extends Component {
    render(){
        const { t, i18n } = this.props;

        // TO DO
        return(
            <NotFoundContent>
                <Logo>
                    {   
                        i18n.language === 'pt' &&
                            <img src={ptLogoColor} alt="Logo"/>
                    }
                    {   
                        i18n.language === 'en' &&
                            <img src={enLogoColor} alt="Logo"/>
                    }
                </Logo>
                <Titulo>
                    {t('PÁGINA NÃO ENCONTRADA')}
                </Titulo>
                <Frase>
                    {t('O link que clicou pode estar quebrado ou a página pode ter sido removida')}
                </Frase>
                {
                    this.props.location.state ?
                        <Links>
                            <Link to={this.props.location.state}>
                                {t('VOLTAR')}
                            </Link>
                        </Links>
                        :
                        <Links>
                            <Link to={'/'+i18n.language}>
                                {t('VOLTAR')}
                            </Link>
                        </Links>
                }
                
            </NotFoundContent>
        )
    }
}

export default translate('translations')(NotFound);

const NotFoundContent = styled.div `
    width: calc(100vw - 80px);
    height: calc(100vh - 80px);
    text-align: center;
    overflow-y: hidden;
    padding: 40px;
    background-color: white;
    z-index: 10001;
    position: absolute;
`
const Logo = styled.div `
    margin-top: 90px;

    img {
        width: 200px;
    }
`
const Titulo = styled.div `
    font-size: 32px;
    color: ${Colors.secondary};
    margin-top: 40px;
    font-weight: 600;
`
const Frase = styled.div `
    margin-top: 30px;
    margin-bottom: 30px;
    color: #535353;
`
const Links = styled.div `
    color: ${Colors.primary};
    font-weight: 600;
    cursor: pointer;

    span a{
        color: ${Colors.primary};
        font-weight: 600;
    }

    a{
        color: ${Colors.primary};
        font-weight: 600;
    }
`



// WEBPACK FOOTER //
// ./src/pages/404/404.page.js